import React from 'react';

const ActivitiesRealEstate = () => {
  return (
    <section id="activities-real-estate">

      <h1>Ingatlankezelés, közös képviselet</h1>

      <header>

        <div id="activities-real-estate-info">

          <h2>Ügyfélszolgálat:</h2>
          <ul>
            <li>H 7.30-18.00</li>
            <li>K-Cs 7.30-16.00</li>
            <li>P 7.30-13:30</li>
            <li>Sz-V Zárva</li>
          </ul>

          <h2>Ügyintéző:</h2>
          <ul>
            <li>Máténé Gál Edina</li>
          </ul>

          <h2>Elérhetőség:</h2>
          <ul>
            <li><a href="tel: +36 59/520-215">59/520-215</a></li>
            <li><a href="tel: +36 20/961-2444">20/961-2444</a></li>
          </ul>

        </div>

        <div id="activities-real-estate-img"></div>

      </header>

      <div id="activities-real-estate-text">

        <p>
          A 18/2012. (IV.25.) számú önkormányzati rendelet (3) bekezdésének értelmében a Kisújszállási Városgazdálkodási Nonprofit Kft. látja 
          <br/>
          el az önkormányzati tulajdonú lakások és helyiségek bérbeadó jogainak gyakorlását, illetve a bérbeadói kötelezettségek teljesítését. 
        </p>

        <p>
          Kezelésünkben lévő önkormányzati tulajdonú bérlakások összetétele a következő:
        </p>

        <div>
          <p>Önkormányzati lakások száma:</p>

          <ul>
            <li>110 db</li>
            <li>23 db szociális</li>
            <li>81 db költségelven bérbe adott</li>
            <li>6 db piaci alapon bérbe adott</li>
          </ul>

          <p>Komfort fokozatok szerint:</p>

          <ul>
            <li>14 db összkomfortos</li>
            <li>76 db komfortos</li>
            <li>11 db félkomfortos</li>
            <li>9 db komfort nélküli</li>
          </ul>

        </div>

        <p>
          2019. évben a közös képviseletünkben lévő társasházak száma 17.
          <br/>
          Az általunk kezelt társasházakban az ingatlanok száma összesen: 313 db.
        </p>

      </div>

    </section>
  );
};

export default ActivitiesRealEstate;